import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Input, Label, FormGroup } from 'reactstrap';
const CabinetFilterOption = ({
  option,
  onSelect,
  selected: _selected = false
}) => {
  const {
    id,
    name
  } = option;
  const handleItem = () => onSelect(option);
  return /*#__PURE__*/React.createElement("div", {
    key: `div-${id}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormGroup, {
    check: true
  }, /*#__PURE__*/React.createElement(Label, {
    check: true
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    className: `t-ts-option t-ts-option-${kebabCase(name)}`,
    key: `chk-${id}`,
    onChange: handleItem,
    checked: _selected
  }), ' ', name))), /*#__PURE__*/React.createElement("hr", null));
};
CabinetFilterOption.propTypes = {
  onSelect: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  selected: PropTypes.bool
};
export default CabinetFilterOption;